// ======================
// SearchFlyout
// ======================
export default class SearchFlyout {
    constructor({
            inputSelector = '.js-search__input',
            resetSelector = '.js-search__reset',
            minLength = 3
        } = {}) {
        this.input = document.querySelector(inputSelector);
        this.resetBtn = document.querySelector(resetSelector);
        this.minLength = minLength;

        if (!this.input) return;

        this.init();
    }

    init() {
        // fade in resetBtn
        this.input.addEventListener('input', () => this.handleInput());

        // clear input value
        this.resetBtn?.addEventListener('click', (event) => this.handleReset(event));
    }

    handleInput() {
        if (this.input.value.length >= this.minLength) {
            this.resetBtn.removeAttribute('disabled');
        } else {
            this.resetBtn.setAttribute('disabled', 'true');
        }
    }

    handleReset(event) {
        event.preventDefault();
        this.input.value = '';
        this.resetBtn.setAttribute('disabled', 'true');
        this.input.focus();
        const resultsContainer = document.querySelector('.SearchOverlay--results');
        resultsContainer.innerHTML = '';
    }
}